export default "__VITE_ASSET__28850e35__"